module.exports = __webpack_public_path__ + "static/media/DBF15C14-0570-427F-AF82-688DEDA061D9.1f1783a9.jpeg";